module.exports = __webpack_public_path__ + "img/account.897cc5a9.svg";